import CryptoJS from "crypto-js";

// Client-side obfuscation for sensitive localStorage values (customercode, customerid, mobile).
const STORAGE_SECRET_KEY = "H3r0H0us1ngF1n@nceLS2024!";

export function setEncryptedItem(key, value) {
  if (value === undefined || value === null) return;
  const encrypted = CryptoJS.AES.encrypt(String(value), STORAGE_SECRET_KEY).toString();
  localStorage.setItem(key, encrypted);
}

export function getDecryptedItem(key) {
  const stored = localStorage.getItem(key);
  if (!stored) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(stored, STORAGE_SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || null;
  } catch (e) {
    return null;
  }
}
